import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  failure: {
    id: 'learning.loading.failure',
    defaultMessage: 'There was an error loading this course.',
  },
  loading: {
    id: 'learning.loading',
    defaultMessage: 'Loading course page…',
  },
});

export default messages;
